import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";
import Paginate from "vuejs-paginate";
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: "VerifyReversePickupFromCustomer",
  components: {
    VueElementLoading,
    Paginate
  },
  mixins:[PageTracker],
  data: function() {
    return {
    Loading: false,
    shippingID:"",
    shipmentData:{},
    checkCount:null,
    PickupQty:[],
    ProductQty:"",
    Comments:[],
    checkboxParcel:false,
    validated:null,
    time:"",
    toDate: "",
    Remarks:"",
    pickupstatus:"",
    Lengthdata:"",
    Widthdata:"",
    Heightdata:"",
    PhyWeight:"",
    Namedata:"",
    volweight:"",
    usermappingstatusdata:[],
    productdetailsdata:[],
    remarksstaus:"",
    QCCheckListDetails:[],
    qualitychecklist:null,
    updateShipmentData:[],
    validatedbox:1,
    datavalue:"",
    Distance:null,
    Pincode:"",
    mandatoryfield:null,
    UniqueCodeArray:[],
    errorshowmessage:null,
    servicebaldata:{},
    usermpadata:[],
    minidorpdown:[],
    substatus:'',
    isLoading: false,
    NonQCRVPType:''

    };
  },
  created: function() {
    this.getdatafunction();
    console.log("Helllo");
  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log("userdetail", userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]["rolename"];
    this.hubname = userdetail.hubdetails[0];
  },
  methods: {

    async getShipmentdetailsbyshippingid() {
      this.productdetailsdata =[];
      this.QCCheckListDetails =[];
      this.checkCount=null;
      this.ProductQty = "";
      this.PickupQty = [];
      this.Comments = [];
      this.shipmentData={};
      this.time="";
      this.Lengthdata="";
      this.Widthdata="";
      this.Heightdata="";
      this.PhyWeight="";
      this.pickupstatus="";
      this.Namedata="";
      this.volweight="";
      this.Distance=null;
      this.Pincode="";
      this.UniqueCodeArray=[];
      this.usermappingstatusdata=[];
      this.servicebaldata={};
     this.usermpadata=[];



      let ShippingID={};
      ShippingID.ShippingID = this.shippingID.trim();


      this.Loading = true;
      await axios.post(apiUrl.api_url +`expose/get/SRRunsheet/shipment/details/for/web`,ShippingID)
        .then(response => {
         if (response.data.code === 200) {
          if (response.data.data.uniquecode !== "XBU00242"){
              this.Loading = false;
                return this.$alertify.error("OFP Shipment not found");
            }else{
              this.shipmentData = response.data.data;
              this.getuserprocesmapstausforpickup();
           }
           this.NonQCRVPType = response.data.data.NonQCRVPType
            if (this.shipmentData.productdetails!==null){
                this.productdetailsdata = this.shipmentData.productdetails;
            }else{
              this.productdetailsdata =[];
            }

            if (this.shipmentData.QCParameters!==null){
              this.QCCheckListDetails = this.shipmentData.QCParameters.QCCheckList;
            }else{
              this.QCCheckListDetails =[];
            }
           this.checkCount=1;
          } else if(response.data.code === 202){
            this.shipmentData={};
            this.checkCount=null;
            this.Loading = false;
            return this.$alertify.error(response.data.message);
          }
          else {
            this.shipmentData={};
            this.checkCount=null;
            this.Loading = false;
            return this.$alertify.error("Shipments not found");
          }
          this.Loading = false;
        })
        .catch(httpException => {
            this.Loading = false;
          return this.$alertify.error("Shipment Details Not Found");
          console.error("exception is:::::::::", httpException);
        });
      },

    selectcheckboxforParcel(ev){
      if (ev.target.checked == true) {
        for(let i in this.productdetailsdata){
          this.PickupQty.push(this.productdetailsdata[i].ProductQty);
          this.validated = 1;
        }
      }else{
        this.PickupQty=[];
        this.validated = null
      }
    },

      reset(){
        this.checkCount=null;
        this.ProductQty = "";
        this.PickupQty = [];
        this.Comments = [];
        this.shippingID="";
        this.shipmentData={};
        this.time="";
        this.Lengthdata="";
        this.Widthdata="";
        this.Heightdata="";
        this.PhyWeight="";
        this.pickupstatus="";
        this.Namedata="";
        this.volweight="";
        this.Distance=null;
        this.Pincode="";
        this.UniqueCodeArray=[];
        this.usermappingstatusdata=[];
        this.servicebaldata={},
        this.usermpadata=[];
        },

  async UpdateVerifyReversePickupFromCustomer(){

  let length=null;
  let width =null;
  let height =null;
  let PhyWeight =null;
  let calculateVolWeight="";

let regex = /^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/;

if (!this.pickupstatus){
  return this.$alertify.error("Please select pickup status");
}else{
if (this.Lengthdata !==null && this.Lengthdata.trim()!==''){
  length = parseFloat(this.Lengthdata);
}else {
length =0;
}

if (this.Widthdata !==null && this.Widthdata.trim()!==''){
  width = parseFloat(this.Widthdata);
}else {
width =0;
}

if (this.Heightdata !==null && this.Heightdata.trim()!==''){
  height = parseFloat(this.Heightdata);
}else {
height =0;
}

if (this.PhyWeight !==null && this.PhyWeight.trim()!==''){
  PhyWeight = parseFloat(this.PhyWeight);
}else {
PhyWeight =0;
}


if (this.pickupstatus =="XBU00074"){
    if (length <= 0 || width <= 0 || height <= 0){
     return this.$alertify.error("LBH Cannot be Zero or Empty");
    }
    else if (PhyWeight <=0 ) {
      return this.$alertify.error("Physical weight Cannot be 0 or Empty");
    }
    else if (length >= 170 || width >= 170 || height >= 170) {
    return this.$alertify.error("LBH Cannot be greater than 170.");
    }else {
      calculateVolWeight = (length * width * height) / 6000;
      this.volweight = calculateVolWeight.toString();
    }
    if (calculateVolWeight <= 0 ){
      return this.$alertify.error("Volumetric weight Cannot be 0 or Empty");
    }

    if (this.productdetailsdata.length){
      let pickupQtyCheck=null;

      for(let i in this.productdetailsdata){
          if (this.PickupQty[i] != this.productdetailsdata[i].ProductQty || !this.PickupQty[i]){
          pickupQtyCheck = 1;
        }
      }

    if (pickupQtyCheck == 1){
    return this.$alertify.error("Product Qty  & Picked Qty should be same.");
  }
}
}
else{

  let count=null;

  if (this.pickupstatus == "XBU00509" && !this.Distance){
    return this.$alertify.error("Distance is required");
  }else if (this.pickupstatus == "XBU00509" && !Number(this.Distance)) {
  return this.$alertify.error("Distance should be Number");
  }

  if (this.pickupstatus == "XBU00509" && this.Pincode && !Number(this.Pincode)){
    return this.$alertify.error("Pincode should be Number");
  }

  if (this.pickupstatus == "XBU00509" && this.Pincode && this.Pincode.length > 6){
    return this.$alertify.error("Pincode should be 6 digit number");
  }

  if (this.pickupstatus == "XBU00509" && !this.Pincode){
   return this.$alertify.error("Pincode is required");
  }

  if (this.pickupstatus == "XBU00509" && !Number(this.Pincode)){
    return this.$alertify.error("Pincode should be Number");
  }

  if (this.pickupstatus == "XBU00509" && this.Pincode.length > 6){
    return this.$alertify.error("Pincode should be 6 digit number");
  }

  if (this.pickupstatus == "XBU00509" && this.Distance && !Number(this.Distance)){
    return this.$alertify.error("Distance should be Number");
  }


if (this.Pincode && this.mandatoryfield ==1 && (this.pickupstatus == "XBU00509")){
  await this.checkPincodeServicebaleorNot();
}

  if (this.productdetailsdata.length){
  let checkcoutntest =null;
  for(let i in this.productdetailsdata){
  if (this.productdetailsdata[i].ProductQty != this.PickupQty[i] || !this.PickupQty[i])
  {
    checkcoutntest =1;
  }
  }
  if (checkcoutntest == 1){
  return this.$alertify.error("Product Qty  & Picked Qty should be same.");
  }
  }
}



if (this.minidorpdown.length && !this.substatus){
    return this.$alertify.error("NPR Sub-Reason should be mandatory.");
}


if (!this.time){
  return this.$alertify.error("Time field should be mandatory.");
}


this.Loading= true;
let distancdata = this.Distance != '' && this.Distance != null && (this.pickupstatus == "XBU00509") ? this.Distance : 0;
let pindcodedata = this.Pincode.trim() !='' && this.Pincode!= null && (this.pickupstatus == "XBU00509") ? this.Pincode : "";

  let ReversePickupUpdate={
    IDProofNumber: "",
    ReAttemptDate: "",
    LastModifiedBy: "",
    Latitude: 0,
    IsSecurityCodeWrongAttempt: false,
    IsPODMarkOnAlternetAddress: false,
    PODPath: "",
    EPaymentName: "",
    EPaymentType: "",
    ProcessCode: "",
    UserProcess: "",
    StatusMarkedFrom: "Web",
    IDProof: "",
    ReceiverMobileNo: "",
    DisputeStatusCode: this.substatus,
    Longitude: 0,
    Amount: "",
    DeviceID: "",
    IsOpenDelivery: false,
    RelationshipWithConsignee: "",
    DeliveryUserName: this.shipmentData.DeliveryUserName != null? this.shipmentData.DeliveryUserName : "",
    OldDeliveryUserOrUserId: 0,
    RunSheetId: 0,
    IsCustomerSigned: false,
    DeviceCapturedDate: "",
    submitDistance: 0,
    DisputeComment:"",
    Distance:distancdata,
    Pincode:pindcodedata,
    CurrentHubID: this.shipmentData.CurrentHubID!= null ? this.shipmentData.CurrentHubID : null
  };


  ReversePickupUpdate.ShippingId = this.shippingID.trim();
  ReversePickupUpdate.Status =  "";
  ReversePickupUpdate.ShipmentStatus = this.shipmentData.Status;
  ReversePickupUpdate.ClientID = 0;
  ReversePickupUpdate.DeliveryUserID = this.shipmentData.DeliveryUserId != null? this.shipmentData.DeliveryUserId.toString() : "";
  ReversePickupUpdate.ReasonCode = this.pickupstatus;
  ReversePickupUpdate.ReceiverName = this.Namedata!=null ? this.Namedata : "";
  ReversePickupUpdate.ShipmentType = this.shipmentData.shipmenttype;

  let d = new Date();
   let year = d.getFullYear();
   let month = d.getMonth()+1;
   let date = d.getDate();
   let hours = d.getHours();
   let minute = d.getMinutes();
   let seconde = d.getSeconds();
   let mydate;

   if (d.getHours().toString().length == 1){
     hours  = "0"+d.getHours();
   }
   if (d.getMinutes().toString().length ==1){
      minute = "0" + d.getMinutes();
   }
   if (d.getSeconds().toString().length ==1){
      seconde = "0"+d.getSeconds();
   }

   if (month.toString().length == 1) {
     mydate = year + "-0" + month + "-" + date + " " + hours + ":" + minute + ":" +seconde;
   }
   if (date.toString().length == 1) {
     mydate = year + "-" + month + "-0" + date + " " + hours + ":" + minute + ":" +seconde;
   }
   if (month.toString().length > 1 && date.toString().length > 1) {
     mydate = year + "-" + month + "-" + date + " " + hours + ":" + minute + ":" +seconde;
   }
  ReversePickupUpdate.DeliveryDateTime = mydate;

  if (this.servicebaldata.code == 204 && this.mandatoryfield ==1){
    this.Loading= false;
    return this.$alertify.error(this.servicebaldata.message);
  }
  await axios.post(apiUrl.api_url + `expose/common/api/srrunsheet/pod`,ReversePickupUpdate)
  .then(response => {
    if (response.data.code == 200 && response.data.message == "success"){
      this.Loading= false;
      this.reset();
      return this.$alertify.success("Shipment Updated Successful");
    }else{
      this.Loading= false;
      return this.$alertify.error(response.data.message);
    }
  }).catch(httpException => {
    this.Loading= false;
    this.$alertify.error("User details not found");
    console.error("exception is:::::::::", httpException);
  });
}
},


 getdatafunction(){
  let d = new Date();
   let year = d.getFullYear();
   let month = d.getMonth()+1;
   let date = d.getDate();
   let setDate;
   if (month.toString().length == 1) {
     setDate = year + "-0" + month + "-" + date;
   }
   if (date.toString().length == 1) {
    setDate = year + "-" + month + "-0" + date;
   }
   if (month.toString().length > 1 && date.toString().length > 1) {
     setDate = year + "-" + month + "-" + date;
   }
   this.datavalue = setDate.toString();
   console.log("this.datavalue",this.datavalue);
},




async getuserprocesmapstausforpickup(){
  let ApplicableFor={};
  ApplicableFor.ApplicableFor = "Web";
  let checkArr=[];
  this.usermpadata=[];
  this.UniqueCodeArray = this.shipmentData.AllowedNDRReasonsCodes.split(',');
  await axios
    .post(
       apiUrl.api_url +`external/getUserProcessMappingDetails/Web`,
      ApplicableFor
    )
    .then(async (response) => {
     if (response.data.code === 200) {

      await response.data.data.map(dqdata=>{
     if (dqdata.title != "Pick up done" && dqdata.title != "Document Collected"){
     if (this.UniqueCodeArray.includes(dqdata.uniquecode.toString())){
        if (this.shipmentData.ClientBusinessAccountId == 834){
           this.usermpadata.push(dqdata);
         }else if (this.shipmentData.ClientBusinessAccountId !== 834 && dqdata.title !="Pickup Unattempted - Heavy Shipment (Vehicle Needed)") {
          this.usermpadata.push(dqdata);
         }
       }

       if (!this.shipmentData.AllowedNDRReasonsCodes && this.shipmentData.ClientBusinessAccountId == 834){
         this.usermpadata.push(dqdata);
       }else if(!this.shipmentData.AllowedNDRReasonsCodes && dqdata.title !="Pickup Unattempted - Heavy Shipment (Vehicle Needed)") {
         this.usermpadata.push(dqdata);
       }

     }
   });

       this.usermappingstatusdata = Object.values(this.usermpadata.reduce((acc,cur)=>Object.assign(acc,{[cur.title]:cur}),{}));

       if (!this.usermappingstatusdata.length){
         this.errorshowmessage = 1;

       }else {

         const nonQCArray = this.usermappingstatusdata.filter(object => {
            return object.title !== 'Product did not meet the given description';
         });

         const rp_ndr_status_code = this.usermappingstatusdata
         const reverse_qc_status_code = nonQCArray
         console.log();
         if(this.NonQCRVPType == null){
            this.usermappingstatusdata = rp_ndr_status_code
         //}else if (this.NonQCRVPType == 'OpenBox' || this.NonQCRVPType == 'ClosedBox' ) {
         }else{
            //Firstcry ClientBusinessAccountId - 834,3
            if(this.shipmentData.ClientBusinessAccountId === 834  || this.shipmentData.ClientBusinessAccountId === 3 ){
              this.usermappingstatusdata = rp_ndr_status_code
            }else {
              this.usermappingstatusdata = reverse_qc_status_code
            }
         }
         this.errorshowmessage = 0;
       }

      } else {
       this.$alertify.error("pickup status not found");
      }
    })
    .catch(httpException => {
      this.$alertify.error("Shipment Details Not Found");
      console.error("exception is:::::::::", httpException);
    });
},



async checkPickupstatus(uniquecode){

let SubReasonObject =[];
this.minidorpdown=[];
this.substatus=""


   SubReasonObject = await this.usermappingstatusdata.filter((statusCode)=>{
    return statusCode.uniquecode == uniquecode;
  });


    if(SubReasonObject.length > 0){
       if(SubReasonObject[0].hasSubStatus != undefined && SubReasonObject[0].hasSubStatus == true) {
         let key_generate = `${uniquecode}_deliverySubstatus`;
          let disputeListObj = SubReasonObject[0][key_generate];
          this.minidorpdown = disputeListObj;

         }
       }

     for(var x= 0; x < this.minidorpdown.length; x++) {
       if(this.shipmentData.ClientBusinessAccountId != 834){
         if(this.minidorpdown[x].uniquecode == 'XBU00521') {
           this.minidorpdown.splice(x, 1);
         }
       }
     }

    if(this.NonQCRVPType != null){
      const firstcrySubreasons = this.minidorpdown.filter(object => {
         return object.title !== 'No Pickup due to QC fail';
      });
      if( this.shipmentData.ClientBusinessAccountId === 834  || this.shipmentData.ClientBusinessAccountId === 3){
      this.minidorpdown = firstcrySubreasons
      }
    }
//old condition
// if (uniquecode == "XBU00376" || uniquecode == "XBU00076"){
// New condition
if (uniquecode == "XBU00509"){
  this.mandatoryfield = 1;
}else {
  this.mandatoryfield = null;
}
  // this.usermpadata
},



 async checkPincodeServicebaleorNot(){
let shipmentmapdata={
"businessservice":"PickUp",
"businessunit":"eComm",
"pincode":this.Pincode,
"businessflow":"Reverse",
"routemode":null
};
 await axios.post(apiUrl.api_url +`external/getcheckPincodeServicable`,
    shipmentmapdata).then(response => {
    if (response.data.code == 200){
      this.servicebaldata = response.data.data;
      return true;
    }else {
      this.servicebaldata = response.data.data;
      return false;
    }
})
},

async myFunction(e) {
if (e.keyCode == 13){
  this.getShipmentdetailsbyshippingid();
}
}
}
};



// WEBPACK FOOTER //
// ./src/views/components/VerifyReversePickupFromCustomer/VerifyReversePickupFromCustomer.component.js